<script lang="ts">
	import ChevronDown from '@icons/ChevronDown.svelte';
	import { Breakpoints } from '@tools';
	import Cross from '@icons/Cross.svelte';

	let {
		name,
		onclick,
		active = false,
		items = []
	}: {
		name: string;
		onclick: () => void;
		active?: boolean;
		items?: {
			name: string;
			clear: () => void;
		}[];
	} = $props();

	const max = $derived(Breakpoints.md ? 4 : Breakpoints.sm ? 2 : 1);
</script>

<div class="button:outline no-icon" aria-pressed={active}>
	{#if Breakpoints.sm || items.length < max}
		<button class="main action" {onclick} aria-pressed={active}>
			<span>{name}</span>
			<ChevronDown />
		</button>
	{/if}
	{#each items.slice(0, max) as item}
		<button class="item" onclick={max === 1 ? onclick : item.clear}>
			<span>{item.name}</span>
			{#if max > 1}
				<Cross />
			{/if}
		</button>
	{/each}
	{#if items.length > max}
		<button class="max action" {onclick}>+{items.length - max}</button>
	{/if}
</div>

<style lang="scss">
	.button\:outline {
		background-color: $colorBackground;
		cursor: default;
		gap: $gap1;
		padding: $gap1;
		align-items: stretch;

		&:hover {
			background-color: $colorBackground !important;
		}

		:global(.chevron-down) {
			width: 0.625em;
			transition: transform $transition;
		}

		&:has(.action:focus-visible) {
			outline: 2px solid $colorForeground;
			outline-offset: -2px;
		}

		&:has(.action:hover) {
			background-color: $colorHover !important;
		}

		&[aria-pressed='true'] {
			background-color: $colorButtonBackground;

			&:hover {
				background-color: $colorButtonBackground !important;
			}

			:global(.chevron-down) {
				transform: rotate(180deg);
			}

			&:has(.action:hover) {
				/* background-color: $colorButtonHover !important; */
				background-color: $colorButtonBackground !important;
			}
		}
	}

	.main {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: $buttonGap;
		line-height: $buttonLine;
		padding: $buttonPaddingVertical $buttonPaddingHorizontal;
		margin: #{$gap1 * -1};
		padding-right: #{$gap1 * 2};

		&:last-child {
			padding-right: $buttonPaddingHorizontal;
			margin-right: #{$gap1 * -1};
		}

		&:focus-visible {
			outline: none;
		}

		:global(.chevron-down) {
			width: 0.625em;
		}
	}

	.item {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: $buttonGap;
		background-color: $colorDropdownBackground;
		color: $colorDropdownForeground;
		padding: calc($buttonPaddingVertical - $gap1 - 1px) calc($buttonPaddingHorizontal - $gap1 - 1px);
		line-height: $buttonLine;
		border-radius: calc(#{$gap1 - 1px} + #{$buttonPaddingVertical + $buttonLine * 0.5});
		border: 1px solid $colorDropdownBackground;
		transition: background-color $transition;

		&:hover {
			background-color: color.adjust($colorDropdownBackground, $lightness: -4%);
		}

		:global(svg) {
			width: 0.625em;
			stroke-width: 2px;
		}
	}

	.max {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: $buttonPaddingVertical $gap4;
		margin: #{$gap1 * -1};
		margin-left: 0;
		padding-left: $gap1;

		&:focus-visible {
			outline: none;
		}
	}
</style>
